<template>
  <div>
    <v-card class='mx-2' outlined>
      <v-card-title>
        <v-container fluid>
          Licenses
          <v-row>
            <v-col cols="12" sm="2" md="1" class="mt-2">
              <span><h5>Filters:</h5></span>
            </v-col>
            <v-col cols="12" sm="6" md="3" xl="2">
              <v-select
                v-model="filterType"
                :items="filterLicenseTypes"
                @change="saveFilters"
                label="License Types"
                multiple
                dense
              ></v-select>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="6" md="3" xl="2">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                clearable
                dense
                @change="searchChange"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <v-data-table v-model="selected" 
        :headers="headers" 
        :items="licenses" 
        :search="search" 
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @update:sort-by="saveSort"
        @update:sort-desc="saveSort"
        :items-per-page='parseInt("-1")'
        no-data-text="No Documents">
        <template v-slot:top>
          <v-dialog v-if="dialog === true" v-model="dialog" max-width="60%" :key="dialogKey">
            <v-card>
              <v-card-title>
                <span class="headline">Edit License {{ wgip }}</span>
              </v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="3" md="3">
                    <v-text-field 
                      v-model="distId" 
                      label="Distributor Cust Id" 
                      placeholder="Distributor's Cust Id, e.g. QUM001">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-text-field 
                      v-model="maxResources"
                      label="Max Resource Count" 
                      type="number"
                      :disabled="licenseVersion < 1"
                      v-validate.initial="'required|min_value:1|max_value:128'"
                      data-vv-name="maxResources"
                      :error-messages="errors.collect('maxResources')">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-text-field 
                      v-model="resourceCount"
                      label="Licensed Resource Count"
                      type="number"
                      v-validate.initial="'required|min_value:0|max_value:128'"
                      data-vv-name="resourceCount"
                      :error-messages="errors.collect('resourceCount')">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :disabled="licenseVersion < 1"
                      :close-on-content-click="false"
                      :return-value.sync="expDate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="expDate"
                          :disabled="licenseVersion < 1"
                          v-validate.initial="'required|date_format:yyyy-MM-dd'"
                          data-vv-name="expDate"
                          :error-messages="errors.collect('expDate')"
                          label="Expiration Date"
                          placeholder="Exp Date (yyyy-MM-dd)"
                          prepend-icon="event"
                          :readonly="false"
                          v-on="on">
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="expDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false; validateDate()">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.menu.save(expDate); validateDate()">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="3" md="1">
                    <v-radio-group
                      v-model="licenseVersion"
                      @change="changeVersion"
                      label="License Version"
                      dense
                    >
                      <v-radio
                        v-for="n in licenseVersions.length"
                        :key="n-1"
                        :label="licenseVersions[n-1]"
                      >
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-radio-group
                      v-model="licenseType"
                      label="License Type"
                      :disabled="licenseVersion < 1"
                      dense
                      v-validate.initial="'required|min_value:0|max_value:2'"
                      data-vv-name="licenseType"
                      :error-messages="errors.collect('licenseType')"
                    >
                      <v-radio
                        v-for="n in licenseTypes.length"
                        :key="n-1"
                        :label="licenseTypes[n-1]"
                      >
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-text-field 
                      v-model="maxCameras"
                      label="Max Camera Count"
                      type="number"
                      :disabled="licenseVersion < 1"
                      v-validate.initial="'required|min_value:0|max_value:128'"
                      data-vv-name="maxCameras"
                      :error-messages="errors.collect('maxCameras')">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-text-field 
                      v-model="cameraCount"
                      label="Licensed Camera Count"
                      type="number"
                      :disabled="licenseVersion < 1"
                      v-validate.initial="'required|min_value:0|max_value:128'"
                      data-vv-name="cameraCount"
                      :error-messages="errors.collect('cameraCount')">
                    </v-text-field>
                  </v-col>
                </v-row>
                </v-container>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn :disabled="disableUpdateButton" color="primary darken-1" @click="save">Save</v-btn>
                <v-btn color="primary darken-1" @click="close">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:item.serNum="{ item }">
          <a :href="systemsLink(item)">
            {{ item.serNum }}
          </a>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class='mr-2' v-clipboard:copy="(item.jwt)" @click="copyJwtTooltipTextChange()"> fa-copy  </v-icon>
            </template>
            <span>{{copyJwtTooltipText}}</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class='mr-2' @click="gwLink(item)"> fa-hdd  </v-icon>
            </template>
            <span>Open gateway page in QxControl</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class='mr-2' @click="edit(item)"> edit  </v-icon>
            </template>
            <span>Edit License</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class='mr-2' @click="deleteItem(item)"> delete  </v-icon>
            </template>
            <span>Delete License</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class='mr-2' @click="showHistory(item)"> fa-clock </v-icon>
            </template>
            <span>Show License History</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>


import env from '../../server.config'

/*  Example API return element
  "0": {
    "id": "10f2489d-adfb-11ed-9e54-0aa5cc65fb18",
    "wgip": "10.237.0.75",
    "version": "2",
    "resourceCount": "97",
    "jwt": "xxxxyyyyyzzzzz...",
    "customerId": null,
    "distId": null,
    "createdBy": "drittman@qumulex.com",
    "createdDate": "2023-02-16 13:08:55",
    "modifiedBy": null,
    "modifiedDate": "2023-02-16 13:08:55",
    "type": "QXP",
    "cameraCount": "10",
    "maxResources": "11",
    "maxCameras": "15",
    "exp": "1516239023"
   */

export default {
  name: "Licenses",
  props: {
    app: Object,
    searchSerNum: String   // serial number passed via route on which to search
  },
  data: () => ({
    sortBy: "createdDate",
    sortDesc: false,
    search: '',
    licenses: [],
    selected: [],
    systemSerNum: '',
    dialog: false,
    dialogKey: 0,
    menu: false,
    licenseId: '',
    wgip: '',
    distId: '',
    currentDistId: '',
    resourceCount: 0,
    cameraCount: 0,
    maxResources: 0,
    maxCameras: 0,
    licenseType: 1, // index into licenseTypes
    licenseTypes: ['QXO', 'QXP', 'QXC'],
    filterLicenseTypes: ['v1', 'QXO', 'QXP', 'QXC'],
    filterType: ['v1', 'QXO', 'QXP', 'QXC'],
    licenseVersion: 1,  // index into licenseVersions
    licenseVersions: ['1', '2'],
    expDate: '',
    copyJwtTooltipText: 'Copy license JWT',
  }),

  created() {
    console.log('Licenses created')
    //this.initialize();
  },

  mounted() {
    console.log('Licenses mounted');
    if (this.searchSerNum?.length) {
      this.search = this.searchSerNum;
    } else if (sessionStorage.getItem('licensesSearchString')) {
      this.search = sessionStorage.getItem('licensesSearchString');
    } else {
      this.search = '';
    }
    let item = sessionStorage.getItem("licensesSortBy"); 
    if (item) this.sortBy = item;
    item = sessionStorage.getItem("licensesSortDesc"); 
    if (item) this.sortDesc = item === 'true';
    item = sessionStorage.getItem('licenseTypeFilter');
    if (item) this.filterType = item.split(",");
    setTimeout(() => {
      this.initialize();
    }, 500);
  },

  computed: {
    headers() {
      return [
        {
          text: 'System S/N',
          align: 'center',
          value: 'serNum'
        },
        {
          text: 'WG Address',
          align: 'center',
          value: 'wgip'
        },
        {
          text: 'Version',
          align: 'left',
          value: 'version'
        },
        {
          text: 'Cust Id',
          align: 'left',
          value: 'customerId'
        },
        {
          text: 'Dist Id',
          align: 'left',
          value: 'distId'
        },
        {
          text: 'Type',
          align: 'left',
          value: 'type',
          filter: value => {
            if (value == undefined) value = 'v1';
            if (this.filterType.length == 0) return false;
            let found = this.filterType.findIndex(str => {
              return str === value+"";  // convert value: any to string
            })
            return found >= 0;
          },
        },
        {
          text: 'Resources',
          align: 'left',
          value: 'resourceCount'
        },
        {
          text: 'Cameras',
          align: 'left',
          value: 'cameraCount'
        },
        {
          text: 'Max Resources',
          align: 'left',
          value: 'maxResources'
        },
        {
          text: 'Max Cameras',
          align: 'left',
          value: 'maxCameras'
        },
        {
          text: 'Expires',
          align: 'left',
          value: 'exp'
        },
        {
          text: 'Date Created',
          align: 'left',
          value: 'createdDate'
        },
        {
          text: 'Date Modified',
          align: 'left',
          value: 'modifiedDate'
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'action',
          sortable: false
        }
      ]
    }, 

    disableUpdateButton() {
      if (this.licenseVersion < 1) {
        return this.errors.has('resourceCount'); // v1 licenses only have resource count field
      } else {
        return this.errors.any();
      }
    }
  },

  methods: {
    initialize() {
      this.getLicenses();
    },

    copyJwtTooltipTextChange() {
      this.copyJwtTooltipText = "Copied";
      setTimeout( () => {
        this.copyJwtTooltipText = "Copy license JWT"
      }, 500)
    },

    systemDetails(item) {
      //console.log('systemDetails' + JSON.stringify(item));
      this.$router.push('/SysDetails/' + item.serNum);
    },

    saveFilters() {
      sessionStorage.setItem('licenseTypeFilter', this.filterType);
    },

    saveSort() {
      sessionStorage.setItem("licensesSortBy", this.sortBy); 
      sessionStorage.setItem("licensesSortDesc", this.sortDesc); 
    },

    searchChange() {
      if (this.search) {
        sessionStorage.setItem('licensesSearchString', this.search);
      } else {
        sessionStorage.setItem('licensesSearchString', "");
      }
    },

    changeVersion() {
      console.log("License Version=", this.licenseVersion);
    },

    systemsLink(item) {
      return window.location.protocol + "//" + window.location.host + `/OpsPortal/#/systems/${item.serNum}`; 
    },

    gwLink(item) {
      let gwUrl = '';
      this.app.restApi({
          method: 'get',
          url: `API/public/system/${item.serNum}/gw`,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          const gwid = Object.values(response.data);
          gwUrl = env.appBaseUrl + `/#/qx/gateways/${gwid}`;
          window.open(gwUrl, '_blank');
        })
        .catch(function (error) {
          if (error.response.status === 404) { // on-prem system?
            const dotIndex = env.appBaseUrl.indexOf(".");
            const appBaseUrl = env.appBaseUrl.substring(dotIndex);
            const splitWgIp = item.wgip.split('.');
            if (splitWgIp.length == 4) {
              let hostbase = 'qx';
              for (let ii=1; ii<=3; ii++) {
                hostbase += ('00' + Number(splitWgIp[ii]).toString(16)).slice(-2);
              }
              gwUrl = `https://${hostbase}-pub${appBaseUrl}`;
              window.open(gwUrl, '_blank');
            }
          } else {
            console.log("Licenses::gwLink() error: ", error);
          }
        });
    },
   
    edit(item) {
      console.log(item);
      this.licenseId = item.id;
      this.wgip = item.wgip;
      this.distId = item.distId;
      this.currentDistId = item.distId;
      this.licenseVersion = this.licenseVersions.findIndex(element => {
        return element == item.version; 
      });
      this.licenseType = this.licenseTypes.findIndex(element => {
        return element == item.type; 
      });
      this.resourceCount = item.resourceCount;
      this.maxResources = item.maxResources;
      this.cameraCount = item.cameraCount;
      this.maxCameras = item.maxCameras;
      this.expDate = item.exp;
      this.dialog = true;
    },

    deleteItem(item){
      console.log(item);
      if (confirm("Are you sure you want to delete license for " + item.wgip + "?")) {
        this.deleteLicense(item.id)
      }
    },

    save() {
      console.log("save " + this.licenseId);
      this.updateLicense(this.licenseId)
      this.dialog = false
    },

    close() {
      this.dialog = false
    },

    getLicenses() {
      this.app.restApi({
          method: 'get',
          url: '/API/public/licenses',
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          this.licenses = Object.values(response.data);
          this.licenses.forEach(element => {
            if (element.exp) element.exp = new Date(element.exp * 1000).toISOString().substring(0,10);  // TODO - Timezone offset
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    updateLicense(id) {
      let url = '/API/public/license/' + id
      url += "?resourceCount=" + this.resourceCount
      if (this.licenseVersion >= 0) url += "&version=" + this.licenseVersions[this.licenseVersion]
      if (this.licenseType >= 0) url += "&type=" + this.licenseTypes[this.licenseType]
      if (this.licenseVersion > 0) url += "&cameraCount=" + this.cameraCount
      if (this.licenseVersion > 0) url += "&maxResources=" + this.maxResources
      if (this.licenseVersion > 0) url += "&maxCameras=" + this.maxCameras
      if (this.licenseVersion > 0 && this.expDate) url += "&exp=" + Date.parse(this.expDate)/1000
      console.log('updateLicense(): url=' + url)
      this.app.restApi({
          method: 'post',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          const updatedLicense = Object.values(response.data);
          console.log(response);
          console.log("updatedLicense = ", updatedLicense[0]);
          if (this.distId != this.currentDistId && this.distId) {
            this.relateLicense(updatedLicense[0].id, this.distId);
          } else if (this.distId != this.currentDistId && !this.distId) {
            this.unrelateLicense(updatedLicense[0].id);
          }  else {
            this.getLicenses() // refresh table
          }
        })
        .catch(error => {
          console.log(error);
          alert("Update License failed (" + error.response.status + ")")
        });
    },

    relateLicense(id, distId) {
      this.app.restApi({
          method: 'post',
          url: `/API/public/distributor/${distId}/license/${id}`,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response);
          this.getLicenses() // refresh table
        })
        .catch(function (error) {
          console.log(error);
          alert("Relate License to " + distId + " failed (" + error.response.status + ")")
        });
    },

    unrelateLicense(id) {
      this.app.restApi({
          method: 'delete',
          url: `/API/public/distributor/license/${id}`,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response);
          this.getLicenses() // refresh table
        })
        .catch(function (error) {
          console.log(error);
          alert("Unrelate License failed (" + error.response.status + ")")
        });
    },

    deleteLicense(id) {
      this.app.restApi({
          method: 'delete',
          url: '/API/public/license/' + id,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(response => {
          console.log(response);
          this.getLicenses() // refresh table
        })
        .catch(function (error) {
          console.log(error);
          alert("Delete License failed (" + error.response.status + ")")
        });
    },

    validateDate() {
      // need this to trigger validator after date picker for close date sets close date text input
      this.$validator.validate('expDate');
    },

    showHistory(item) {
      console.log("showHistory ", item.id)
      this.$router.push('/licenseHistory/' + encodeURIComponent(item.wgip))
    },

  }
}
</script>
